module.exports = __webpack_public_path__ + "static/img/hardDR1.701729d1.png";